import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";
import { MarketingTeamCollaborationPage } from "../components/marketing/MarketingTeamCollaborationPage";

export const Route = createFileRoute("/product/team-collaboration")({
  head: () => marketingHead("/product/team-collaboration"),
  component: MarketingTeamCollaborationPage,
});
